module.exports = __webpack_public_path__ + "img/analysis.a3e4551c.png";